"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var pickBy_1 = __importDefault(require("lodash/pickBy"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var reselect_1 = require("reselect");
var formatters_1 = require("utils/formatters");
var general_1 = require("utils/general");
var single_1 = require("utils/selectors/single");
var context_1 = __importDefault(require("./context"));
var selectBaseCurrency = (0, reselect_1.createSelector)(single_1.selectMyCompany, function (myCompany) { return myCompany === null || myCompany === void 0 ? void 0 : myCompany.baseCurrency; });
var Money = function (_a) {
    var amount = _a.amount, _b = _a.fallbackText, fallbackText = _b === void 0 ? '' : _b, props = __rest(_a, ["amount", "fallbackText"]);
    var baseCurrency = (0, react_redux_1.useSelector)(selectBaseCurrency);
    var context = (0, react_1.useContext)(context_1.default);
    var _c = __assign(__assign({}, (0, pickBy_1.default)(context, function (v) { return v !== undefined; })), props), isRounded = _c.isRounded, isShortened = _c.isShortened, currency = _c.currency, asForeignCurrency = _c.asForeignCurrency, fixedDecimals = _c.fixedDecimals;
    // ToDo if currency && baseCurrency && baseCurrency !== currency use international format (i.e. US$, A$)
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, general_1.trueOr0)(amount)
            ? (0, formatters_1.formatMoney)(isRounded ? Math.round(amount) : amount, currency !== null && currency !== void 0 ? currency : baseCurrency, isShortened, isRounded ? 0 : 2, fixedDecimals && !isRounded ? 2 : undefined, asForeignCurrency)
            : fallbackText }));
};
exports.default = Money;
